import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
//-----------------------------------------------
import Hero from "../../components/Details/Hero/Hero";
import Box from "../../components/Details/box/Box";
import Video from '../../components/Details/Video';
import Frame from '../../components/Details/Frame';
import UpButton from '../../components/UpButton';
import SubServPart from '../../components/SubServPart' ;
//============================================
import { useParams , useNavigate} from "react-router-dom";
import { Helmet } from "react-helmet";
import { products } from "../../Data/ProductsDetails";
import {products_last_part} from '../../Data/product_new' ;


const ProductsDetails = ({scroll}) => {
  let thisProduct;
  const { ID } = useParams();
  thisProduct = products?.find(a => +a.id === +ID) ;
  const navigate = useNavigate();
  if(thisProduct){
  var {
    productTitle,
    img_1,
    img_2,
    title_1,
    title_2,
    sub_title_1,
    sub_title_2,
    content_1,
    content_2,
    links,
    vSrc,
    vTitle,
    vContent,
    vHeader,
    fContent,
    fTitle,
    fImg,
  }=thisProduct;}else{navigate('/');}
  return (
    <div>
      <Helmet>
        <title>Millensys - Products Details</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero
          productTitle={productTitle}
        />
        <Box
          img_1={img_1}
          img_2={img_2?img_2:null}
          title_1={title_1}
          title_2={title_2?title_2:null}
          sub_title_1={sub_title_1}
          sub_title_2={sub_title_2?sub_title_2:null}
          content_1={content_1}
          content_2={content_2?content_2:null}
          links={links? links : null }
        />
        { vSrc && 
        <Video
          vSrc={vSrc}
          vTitle={vTitle}
          vContent={vContent}
          vHeader={vHeader}
        />}
        {fImg && 
        <Frame
          fContent={fContent}
          fTitle={fTitle}
          fImg={fImg}
        />
        }
        {productTitle ==='Modular Enterprise Healthcare Platform' && (
          <SubServPart products={products_last_part} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default ProductsDetails;
